<app-hts-code-card [result]="result" [isStale]="isStale" [isDimmed]="isDimmed">
  <div ngProjectAs="[card-actions]" class="hts-assistant-result__actions" *ngIf="isShowActions">
    <button
      type="button"
      class="hts-assistant-result__action"
      [class.hts-assistant-result__action--done]="isCatalogDone"
      [class.hts-assistant-result__action--muted]="isStale"
      [disabled]="isSaveDisabled"
      nz-tooltip
      nzTooltipPlacement="left"
      [nzTooltipTitle]="saveTooltipKey | translate"
      (click)="onSave()"
    >
      <img *ngIf="!isSaving" src="assets/icons/icon_insert_catalog.svg" alt="" />
      <i *ngIf="isSaving" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="hts-assistant-result__action"
      [class.hts-assistant-result__action--done]="isInserted"
      [class.hts-assistant-result__action--muted]="isStale"
      [disabled]="isInsertDisabled"
      nz-tooltip
      nzTooltipPlacement="left"
      [nzTooltipTitle]="insertTooltipKey | translate"
      (click)="onInsert()"
    >
      <img *ngIf="!isInserting" src="assets/icons/icon_insert_item.svg" alt="" />
      <i *ngIf="isInserting" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="hts-assistant-result__action"
      [class.hts-assistant-result__action--muted]="isStale"
      [disabled]="isStartOverDisabled"
      nz-tooltip
      nzTooltipPlacement="left"
      [nzTooltipTitle]="startOverTooltipKey | translate"
      [attr.aria-label]="'HTS_ASSISTANT.START_OVER' | translate"
      (click)="onStartOver()"
    >
      <i class="fa fa-undo" aria-hidden="true"></i>
    </button>
  </div>

  <div ngProjectAs="[card-footer]" class="hts-assistant-result__note hts-assistant-result__note--done" *ngIf="isShowDoneNote">
    <i class="fa fa-check" aria-hidden="true"></i>
    <span *ngIf="isInserted">{{ "HTS_ASSISTANT.RESULT.INSERTED" | translate }}</span>
    <span *ngIf="isShowBothDone">&nbsp;·&nbsp;</span>
    <span *ngIf="isCatalogDone">{{ catalogNoteKey | translate }}</span>
  </div>

  <div ngProjectAs="[card-footer]" class="hts-assistant-result__note hts-assistant-result__note--stale" *ngIf="isShowStaleNote">
    {{ "HTS_ASSISTANT.RESULT.SUPERSEDED" | translate }}
  </div>
</app-hts-code-card>
